/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React, { useEffect, useState } from "react";
import { SpinnerLoading } from "../utils/SpinnerLoading";
import { ErrorMessage } from "../utils/ErrorMessage";
import { fetchRecords } from "../utils/AppUtil";
import { Link } from "react-router-dom";

class WallPost {
    deceasedId: string;
    message: string;
    deceased: string;
    subscriber: string;
    createdDateDisplay: string;
    constructor(deceasedId: string, message: string, deceased: string, subscriber: string, createdDateDisplay: string) {
        this.deceasedId = deceasedId;
        this.message = message;
        this.deceased = deceased;
        this.subscriber = subscriber;
        this.createdDateDisplay = createdDateDisplay;
    }
}

type DeceasedMemorialWallPostsProps = {
    endpoint: string;
    deceasedId: string;
    recordCount: number;
}

export const DeceasedMemorialWallPosts: React.FC<DeceasedMemorialWallPostsProps> = (props): JSX.Element => {

    const [records, setRecords] = useState<WallPost[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [httpError, setHttpError] = useState(null);
    const [endpoint, setEndpoint] = useState(`${props.endpoint}/${props.deceasedId}/approved?count=${props.recordCount}`);

    // Do not change this or put any additional code in here without checking with
    // the team first.
    useEffect(() => {

        fetchRecords(endpoint, processData)
        .catch((error) => {
            setIsLoading(false);
            setHttpError(error.message);
        });

    }, [endpoint]);

    // You may edit this function to manipulate the way your code is processed.
    const processData = (responseJson: any) => { // Do not edit these parameters, just the content of this function.
        const recordData: WallPost[] = [];
    
        for(const key in responseJson) {
            const record: any = responseJson[key];
            const deceasedId: string = record["deceasedId"];
            const message: string = record["message"];

            let deceased: string = (record["deceasedFirstName"] ? record["deceasedFirstName"] : "") + " " + (record["deceasedLastName"] ? record["deceasedLastName"] : "");
            if(!record["deceasedId"]) {
                deceased = "Not Specified";
            }

            let subscriber: string = "Anonymous";
            let isAnonymous: boolean = record["isAnonymous"]
            if(!isAnonymous) {
                subscriber = (record["firstName"] ? record["firstName"] : "") + " " + (record["lastName"] ? record["lastName"] : "");
            }

            const createdDateDisplay: string = record["createdDateDisplay"];

            recordData.push(new WallPost(deceasedId, message, deceased, subscriber, createdDateDisplay));
            
        }
        setRecords(recordData);
        setIsLoading(false);
    }

    if(isLoading) {
        return(
            <SpinnerLoading />
        )
    }

    if(httpError) {
        return(
            <ErrorMessage error={httpError} />
        )
    }

    const result: React.ReactElement[] = [];

    records.forEach((wallPost, index) => {
        result.push(
            <div key={index} className="wall-post d-flex py-3">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 15.5V0H0L16 15.5Z" fill="#E9ECEF"/>
                </svg>
                <div className="wall-post-block d-flex flex-column gap-3 jc-txt-body fs-6 jc-bg-med p-3 w-100">
                    <i>{wallPost.message}</i>
                    <span className="fs-7">{wallPost.subscriber} - {wallPost.createdDateDisplay}</span>
                </div>   
            </div>
        )
    });

    return (
        <div className="card card-wall-posts deceased-wall-posts jc-border-12">
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Memorial Wall Posts</p>
            </div>

            <div className="card-body">
                {result}
            </div>

            <div className="card-footer d-flex justify-content-end">
                <button type="button" className="btn btn-dark jc-txt-body jc-txt-light" data-bs-toggle="modal" data-bs-target="#modalMessage" style={{whiteSpace: "nowrap"}}>Write a Message</button>
            </div>
        </div>
    );
}